import type { CommentsNavigationState } from "@circle-react/components/CommentsCompass/types";
import { useLocation } from "@tanstack/react-router";

import { useReplaceLocationState } from "@/react/hooks/usePostModalNavigation";

export const useCommentsSectionFocus = () => {
  const replaceLocationState = useReplaceLocationState();
  const shouldFocusOnCommentsSection = useLocation({
    select: location =>
      (location.state as CommentsNavigationState | undefined)
        ?.shouldFocusOnCommentsSection,
  });
  const setShouldFocusOnCommentsSection = (shouldFocus: boolean) => {
    replaceLocationState({ shouldFocusOnCommentsSection: shouldFocus });
  };

  return {
    shouldFocusOnCommentsSection,
    setShouldFocusOnCommentsSection,
  };
};
